module.exports = __webpack_public_path__ + "static/team-daniel-palke-avatar-170px-OberionIO-021391a740e9099bd164d61e546c4820.jpg";